<template>
  <div class="statistic-widget-design-quantity">
    <h5 class="mb-0 title">Design Quantity</h5>
    <Chart :config="chartConfig" class="chart" />
  </div>
</template>

<script>
import Chart from '@/components/Chart.vue'
export default {
  components: {
    Chart
  },
  computed: {
    data() {
      return this.config?.data
    },
    chartConfig() {
      let options = {
        chart: {
          type: 'areaspline'
        },
        yAxis: {
          visible: false
        },
        tooltip: {
          shared: true,
          headerFormat: `<b>${this.data?.labels?.label}: {point.x}</b><br>`
        },
        plotOptions: {
          spline: {
            dataLabels: {
              enabled: true,
              format: '{y}'
            }
          },
          areaspline: {
            color: '#32cd32',
            fillColor: {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, '#32cd32'],
                [1, '#32cd3200']
              ]
            },
            threshold: null,
            marker: {
              lineWidth: 1
            },
            dataLabels: {
              enabled: true,
              format: '{y}'
            }
          }
        }
      }
      return {
        options: Object.assign(options, this.options(this.data || {}))
      }
    }
  },
  methods: {
    options(items) {
      let results = {
        categories: [],
        main: [
          {
            name: items.labels?.completed,
            data: []
          },
          {
            name: items.labels?.mapping,
            type: 'spline',
            data: []
          },
          {
            name: items.labels?.['in-production'],
            type: 'spline',
            data: []
          }
        ]
      }
      items?.data.forEach((item) => {
        results.categories.push(item.label)
        results.main[0].data.push(item?.completed)
        results.main[1].data.push(item?.mapping)
        results.main[2].data.push(item?.['in-production'])
      })
      return {
        xAxis: {
          categories: results.categories,
          lineWidth: 0,
          tickLength: 0
        },
        series: [...results.main]
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-design-quantity {
  .chart {
    max-height: 350px;
  }
}
</style>
